import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { AssetBulkUploadComponent } from "./asset-bulk-upload/asset-bulk-upload.component";
import { AssetsComponent } from "./assets.component";
import { CreateAssetComponent } from "./create-asset/create-asset.component";
import { ManageAssetComponent } from "./manage-asset/manage-asset.component";

@NgModule({
  declarations: [AssetBulkUploadComponent, AssetsComponent, CreateAssetComponent, ManageAssetComponent],
  imports: [CoreModule, SharedModule],
  exports: [AssetBulkUploadComponent, AssetsComponent, CreateAssetComponent, ManageAssetComponent],
})
export class AssetModule {}
